export default "__VITE_ASSET__ex0Xs6fh__"